import { MouseEvent, useState } from "react";

export default function useAnchoring(onBlur?: () => void) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget.parentElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (onBlur) onBlur();
  };
  const open = Boolean(anchorEl);
  return { anchorEl, handleClick, handleClose, open };
}
